// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}

ion-card {
  height: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
}

.intestazione {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

ion-card-content {
  flex: 1;
  min-height: 0;
}

.link-giorni {
  display: flex;
  flex-wrap: wrap;
  gap: 2px 6px;
  padding: 0 16px 12px;
}
.link-giorni button {
  background: none;
  border: 0;
  padding: 2px;
  font-size: 0.7rem;
  color: var(--ion-color-medium);
  cursor: pointer;
}
.link-giorni button:hover, .link-giorni button:focus-visible {
  color: var(--ion-color-primary);
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/app/_components/charts/bar-chart/bar-chart.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;AAAF;;AAGA;EACE,OAAA;EACA,aAAA;AAAF;;AAGA;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;AAAF;AAEE;EACE,gBAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;EACA,8BAAA;EACA,eAAA;AAAJ;AAEI;EAEE,+BAAA;EACA,0BAAA;AADN","sourcesContent":[":host {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\nion-card {\n  height: 100%;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n// Feature 161: comandi del grafico (es. 7/30 gg) accanto al titolo, che va a capo invece di finirci sotto.\n.intestazione {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\nion-card-content {\n  flex: 1;\n  min-height: 0;\n}\n\n.link-giorni {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2px 6px;\n  padding: 0 16px 12px;\n\n  button {\n    background: none;\n    border: 0;\n    padding: 2px;\n    font-size: 0.7rem;\n    color: var(--ion-color-medium);\n    cursor: pointer;\n\n    &:hover,\n    &:focus-visible {\n      color: var(--ion-color-primary);\n      text-decoration: underline;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
